import { BaseEntity } from "yt-ng-framework";

export class GotovinskiKomitent extends BaseEntity{
    constructor(){
        super();
    }

    Naziv: string = null;
    SourceID: number = null;
    Pib: string = null;
    MatBr: string = null;
    Adresa: string = null;
    MestoID: number = null;

    Deserialize(input: any){
        this.ID = input.ID;
        this.Naziv = input.Naziv;
        this.SourceID = input.SourceID;
        this.Pib = input.Pib;
        this.MatBr = input.MatBr;
        this.Adresa = input.Adresa;
        this.MestoID = input.MestoID;
        return this;
    }

    Serialize(input:GotovinskiKomitent){
        return input;
    }
}